import type { CSSProperties } from 'react';

/** Stagger index for the `.enter` entry animation (styles/motion.css): `style={stagger(i)}`. */
export const stagger = (index: number): CSSProperties => ({ '--i': index }) as CSSProperties;
